import axios from 'axios';
import store from '@/store';
import router from '@/router';

export const URL_API = process.env.VUE_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: URL_API+'api/v1/',
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        ...config.headers,
    };
    if (!(config.data instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
    }
    config.headers = headers;
    return config;
});

api.interceptors.response.use(
    response => {
      // Se a resposta for bem-sucedida, apenas retorne a resposta
      return response;
    },
    error => {
      // Se o código de erro for 401, redirecione para a tela de login
      if (error.response.status === 401 && store.getters['auth/isAuthenticated']) {
        store.dispatch('auth/logout');
        router.push('/login');
      }
  
      // Retorne qualquer erro que não seja 401 para ser tratado posteriormente
      return Promise.reject(error);
    }
  );

export const login = axios.create({
    baseURL: URL_API+'api/',
    headers: { 'Content-type': 'application/json', 'Accept': 'application/json'},
    withCredentials: true,
});

